(function () {
  if (window.__moxFacetSearchBound) return;
  window.__moxFacetSearchBound = true;

  var HIDDEN_CLASS = 'mox-hidden';

  function normalize(value) {
    return (value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim();
  }

  function filterFacetOptions(input) {
    // Limitamos el alcance al facet que contiene el buscador
    const group = input.closest('.hdt-filter-group');
    if (!group) return;

    const list = group.querySelector('.hdt-filter-group__list');
    if (!list) return;

    const query = normalize(input.value);

    list.querySelectorAll('.hdt-filter-group__list-item').forEach((item) => {
      // Input vacio: restauramos todas las opciones
      if (!query) {
        item.classList.remove(HIDDEN_CLASS);
        return;
      }

      // Las marcas ya seleccionadas siempre quedan visibles
      const checkbox = item.querySelector('input[type="checkbox"]');
      if (checkbox && checkbox.checked) {
        item.classList.remove(HIDDEN_CLASS);
        return;
      }

      const label = item.querySelector('.hdt-facets-label > span:first-of-type');
      const name = normalize(label ? label.textContent : '');

      item.classList.toggle(HIDDEN_CLASS, name.indexOf(query) === -1);
    });
  }

  // Delegado en document: sobrevive al re-render AJAX de los facets
  document.addEventListener('input', function (event) {
    const input = event.target;
    if (!(input instanceof HTMLElement)) return;
    if (!input.matches('input[data-mox-facet-search]')) return;

    // Evitamos que el evento llegue al form de facets (submit / re-render)
    event.stopPropagation();

    filterFacetOptions(input);
  });

  // Fase de captura: el input no debe disparar el submit/re-render de facets
  document.addEventListener(
    'change',
    function (event) {
      const input = event.target;
      if (!(input instanceof HTMLElement)) return;
      if (!input.matches('input[data-mox-facet-search]')) return;

      event.stopPropagation();
    },
    true
  );

  // Enter dentro del buscador no debe enviar el formulario de filtros
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter') return;

    const input = event.target;
    if (!(input instanceof HTMLElement)) return;
    if (!input.matches('input[data-mox-facet-search]')) return;

    event.preventDefault();
  });
})();
